import { render, staticRenderFns } from "./PalletDialog.vue?vue&type=template&id=a0a7e8d2&scoped=true&"
import script from "./PalletDialog.vue?vue&type=script&lang=js&"
export * from "./PalletDialog.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a0a7e8d2",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("D:\\PhpstormProjects\\warehouse\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('a0a7e8d2')) {
      api.createRecord('a0a7e8d2', component.options)
    } else {
      api.reload('a0a7e8d2', component.options)
    }
    module.hot.accept("./PalletDialog.vue?vue&type=template&id=a0a7e8d2&scoped=true&", function () {
      api.rerender('a0a7e8d2', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "web/typo3conf/ext/ig_warehouse/Resources/Public/Src/JavaScript/components/common/pallet/PalletDialog.vue"
export default component.exports